import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { Address } from '@thirdweb-dev/sdk';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

async function fetcher(
  poolAddress: Address | null | undefined,
  config: ApplicationConfig | undefined
) {
  if (!poolAddress) {
    return false;
  }

  try {
    const { data } = await axios.get<void, AxiosResponse<unknown>>(
      `${config?.URLS
        .middlewareUrl}/kim-master/active-pool/${poolAddress.toLowerCase()}`
    );

    return !!data;
  } catch (e) {
    return false;
  }
}

export function useIsActivePool(poolAddress: Address | null | undefined) {
  const config = useConfig();

  return useQuery(
    [QueryKeys.IS_ACTIVE_POOL, poolAddress],
    () => {
      return fetcher(poolAddress, config);
    },
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 0
    }
  );
}
